<template>
  <vjs-modal :name="name"
             v-bind="$options.propsData"
             :icon="icon">
    <template v-if="events.length" slot="body-content">
      <h3 class="mb-3">
        Events on this day:
      </h3>
      <ul class="clean-list">
        <li v-for="(event, i) of events" :key="`${event.id}_${i}`" class="my-1 d-flex flex-row align-items-center">
          <div class="fc-daygrid-event-dot" :style="{ 'border-color': calcEventColour(event.extendedProps) }" />
          <button type="button" class="link-like" @click="() => close(false, event)">
            <img class="mr-2" style="height: 40px; width: 40px;"
                 :src="event.extendedProps.image"
                 :alt="event.title">
            {{ event.title }}
          </button>
        </li>
      </ul>
    </template>
    <template v-else slot="body-content">
      <div :style="{ fontWeight: `bold`, color: `gray`, fontStyle: `italic`, paddingBottom: `2em` }">
        No events.
      </div>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" @click="() => close(true)">
        New Event
      </b-button>
      <b-button variant="ss" @click="() => close(false)">
        Close
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `cal-day-modal`,
  components: { VjsModal },
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: `cal-day-modal`,
    },
    icon: {
      type: String,
      required: false,
      default: `la la-list-ul`,
    },
    events: {
      type: Array,
      required: true,
    },
  },
  methods: {
    close(confirm, event) {
      if (event) {
        this.$emit(`next-modal`, {
          event,
        });
      }
      this.complete({
        confirm,
      });
    },
    calcEventColour(event_props) {
      if (event_props.status === `ERR`) return `red`;
      else {
        if (event_props.recurring) {
          return `purple`;
        } else {
          return `orange`;
        }
      }
    },
  },
};
</script>
